import { Maximize2, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface SkillInstructionsDialogProps {
  open: boolean;
  onOpenChange(open: boolean): void;
  value: string;
  onChange(value: string): void;
  disabled?: boolean;
}

export function SkillInstructionsDialog({
  open,
  onOpenChange,
  value,
  onChange,
  disabled = false,
}: SkillInstructionsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="flex h-[92vh] w-[95vw] max-w-[95vw] flex-col gap-0 overflow-hidden rounded-xl p-0"
        hideCloseButton
      >
        <DialogHeader className="flex-row items-start justify-between border-b border-grey-100 px-5 py-4 text-left">
          <div>
            <DialogTitle className="flex items-center gap-2 text-base text-grey-900">
              <Maximize2 className="h-4 w-4 text-grey-400" />
              Instructions de la compétence
            </DialogTitle>
            <DialogDescription className="mt-1 text-xs text-grey-500">
              Modifiez le prompt complet. Les changements restent liés au même brouillon.
            </DialogDescription>
          </div>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={() => onOpenChange(false)}
            className="h-8 w-8 shrink-0 hover:translate-y-0 hover:shadow-none"
            aria-label="Fermer l’éditeur agrandi"
          >
            <X className="h-4 w-4" />
          </Button>
        </DialogHeader>
        <div className="min-h-0 flex-1 bg-grey-50 p-4 md:p-6">
          <textarea
            value={value}
            onChange={(event) => onChange(event.target.value)}
            disabled={disabled}
            className="h-full w-full resize-none rounded-lg border border-grey-200 bg-white p-4 font-mono text-sm leading-relaxed text-grey-900 outline-none transition focus-visible:border-grey-500 focus-visible:ring-2 focus-visible:ring-grey-200"
            aria-label="Instructions de la compétence en plein écran"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
